import { AUTH_ACTION } from '../types';

export const authReducer = (state = {
    logIn: {
        isGuestAuthenticated: false,
        isAdminAuthenticated: false
    }
}, action) => {
    switch (action.type) {
        case AUTH_ACTION:
            return {
                ...state,
                logIn: action.payload,
            };
        default:
            return state;
    }
};